<template>
    <div class="modal fade" data-backdrop="static" id="addProductSuccessModal" tabindex="-1" role="dialog" aria-labelledby="addProductSuccessModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Success</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>Product has been saved successfully!</p>
                </div>

				<div class="modal-footer" style = "flex: 0 0 auto">
					<div class="mt-2" style="text-align: center">
						<button
							type="button"
							class="btn btn-primary"
							data-dismiss="modal"
							@click = "closeModal"
							>Close
						</button>
					</div>
				</div>

                <!-- <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal" data-dismiss="modal">Close</button>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'AddProductConfirmModal',
    data() {
        return {

        }
    },
    props: {

    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        },
    },
}
</script>

<style lang="scss">

</style>
